module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/Sort.73d8e212.svg";